<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-toggle auto-hide="false">
            <img src="../assets/svg/logo-toolbar.svg">
          </ion-menu-toggle>
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-button class="btn-back" @click="$router.push('/yatch-details/'+$route.params.id)">Back</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <bg :opaque="0"></bg>
      <ion-grid>
        <ion-row class="row-boxed">
          <ion-col size-xs="12">
            <div class="text-right">
              <ion-button class="mt-20" @click="addWorkList" v-if="$store.state.user_role != 'client'">Add worklist</ion-button>
            </div>
          </ion-col>
          <ion-col size-xs="12">
            <ion-list>
              <ion-item v-for="(w) in workLists" :key="'worklist-'+w.name">
                <ion-avatar slot="end">
                  <ion-button @click="$router.push('/worklist/report/details/' + w.id)">Create</ion-button>
                  <ion-button @click="$router.push('/worklist/report/edit/' + w.id)" v-if="$store.state.user_role != 'client'">Edit</ion-button>
                  <ion-button @click="editName(w.id, w.name)" v-if="$store.state.user_role != 'client'">Edit name</ion-button>
                  <ion-button @click="() => deleteWorkList(w.id, w.name)" v-if="$store.state.user_role != 'client'">Delete</ion-button>
                </ion-avatar>
                <ion-label>{{ w.name }}</ion-label>
              </ion-item>
              <ion-item v-if="!workLists.length">
                <ion-label>No work lists has been created</ion-label>
              </ion-item>
            </ion-list>
          </ion-col>
        </ion-row>

      </ion-grid>
      <loader :visible="loader"></loader>
    </ion-content>
  </ion-page>
</template>

<script>
import axios from "axios";
// import Vue from "vue";

export default {
  name: "WorklistReport",
  data: function() {
    return {
      loader: false,
      workLists: []
    }
  },
  methods: {
    getWorkListReports() {
      axios.post(this.apiUrl + '/api/v1/get-worklist-reports', { api_token: this.$store.state.api_token, id: this.$route.params.id })
          .then((response) => {
            let res = response.data
            if(res.data) {
              this.workLists = res.data
            }
            this.loader = false;
          })

    },
    addWorkList() {
      return this.$ionic.alertController
          .create({
            header: 'New worklist',
            inputs: [
              {
                name: 'worklist_name',
                id: 'worklist_name',
                placeholder: 'Name',
              },
            ],
            buttons: [
              {
                text: 'Back',
                role: 'cancel',
                cssClass: 'secondary',
              },
              {
                text: 'Insert',
                handler: async(value) => {
                  let name = value.worklist_name
                  if(name) {
                    this.loader = true;
                    axios.post(this.apiUrl + '/api/v1/save-worklist', { api_token: this.$store.state.api_token, name: name, yacht_id: this.$route.params.id })
                        .then(async(response) => {
                          let res = response.data
                          if(res.status == 1) {
                            this.getWorkListReports()
                            const toast = await this.$ionic.toastController.create({
                              message: 'Worklist added succesfully',
                              color: 'success',
                              position: 'bottom',
                              duration: 2000
                            })
                            await toast.present();
                          }
                        })
                  } else {
                    const toast = await this.$ionic.toastController.create({
                      message: 'Yacht name is required',
                      color: 'danger',
                      position: 'bottom',
                      duration: 3000
                    })
                    await toast.present();
                    this.insert()
                  }
                },
              },
            ],
          })
          .then(a => a.present())
    },
    editName(id, name) {
      return this.$ionic.alertController
          .create({
            header: 'Edit worklist',
            inputs: [
              {
                name: 'worklist_name',
                id: 'worklist_name',
                placeholder: 'Name',
                value: name
              },
            ],
            buttons: [
              {
                text: 'Back',
                role: 'cancel',
                cssClass: 'secondary',
              },
              {
                text: 'Edit',
                handler: async(value) => {
                  let name = value.worklist_name
                  if(name) {
                    this.loader = true;
                    axios.post(this.apiUrl + '/api/v1/save-worklist', { api_token: this.$store.state.api_token, name: name, yacht_id: this.$route.params.id, id: id })
                        .then(async(response) => {
                          let res = response.data
                          if(res.status == 1) {
                            this.getWorkListReports()
                            const toast = await this.$ionic.toastController.create({
                              message: 'Work list edited succesfully',
                              color: 'success',
                              position: 'bottom',
                              duration: 2000
                            })
                            await toast.present();
                          }
                        })
                  } else {
                    const toast = await this.$ionic.toastController.create({
                      message: 'Yacht name is required',
                      color: 'danger',
                      position: 'bottom',
                      duration: 3000
                    })
                    await toast.present();
                    this.insert()
                  }
                },
              },
            ],
          })
          .then(a => a.present())
    },
    deleteWorkList(id, name){
      return this.$ionic.alertController
          .create({
            header: 'Are you sure to delete "' + name + '" work list?',
            buttons: [
              {
                text: 'Cancel',
                role: 'cancel',
                cssClass: 'secondary',
                handler: () => {
                },
              },
              {
                text: 'Delete',
                handler: async() => {
                  this.loader = true
                  axios.post(this.apiUrl + '/api/v1/delete-worklist', { api_token: this.$store.state.api_token, id: id })
                      .then(() => {
                        this.getWorkListReports()
                      })
                },
              },
            ]
          })
          .then(a => a.present())
    }
  },
  mounted: async function() {
    this.getWorkListReports()
  }
}
</script>

<style scoped>
ion-avatar {
  min-width: 320px;
  text-align: right;
}
</style>